import {
  Navbar,
  Hero,
  Audiences,
  Services,
  Process,
  Benefits,
  Work,
  Pricing,
  Team,
  FAQ,
  FinalCTA,
  Footer,
} from "@/components/landing";

export function LandingPage() {
  return (
    <div className="page text-ink">
      <Navbar />
      <main>
        <Hero />
        <Audiences />
        <Services />
        <Process />
        <Benefits />
        <Work />
        <Pricing />
        <Team />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
